
import AxiosClient from "../../../services/axios.services";

class  CompetencyQuestionServices {
  getCompetencyQuestions = params =>
    AxiosClient.get("/api/app/evaluacion_plantilla_competencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getCompetencyQuestion = id =>
    AxiosClient.get(`/api/app/evaluacion_plantilla_competencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCompetencyQuestion = data =>
    AxiosClient.post("/api/app/evaluacion_plantilla_competencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCompetencyQuestion = (id, data) =>
    AxiosClient.put(
      `/api/app/evaluacion_plantilla_competencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteCompetencyQuestion = id =>
    AxiosClient.delete(`/api/app/evaluacion_plantilla_competencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CompetencyQuestionServices();